/* ==========================================
   IMPORT PROJECTS
========================================== */
import smartride from "./projects/smartride";
import clinicManagement from "./projects/clinicManagement";
import marathiMatrimony from "./projects/marathiMatrimony";
import horyzenWebsite from "./projects/horyzenWebsite";
import etoeProduction from "./projects/etoeProduction";
import aiGymTrainer from "./projects/aiGymTrainer";

/* ==========================================
   ALL PROJECTS
========================================== */
export const projects = [
  smartride,
  clinicManagement,
  marathiMatrimony,
  horyzenWebsite,
  etoeProduction,
  aiGymTrainer
].sort((a, b) => a.id - b.id);

/* ==========================================
   FEATURED PROJECTS
========================================== */
export const featuredProjects = projects.filter(
  project => project.featured
);

/* ==========================================
   PROJECT CATEGORIES
========================================== */
export const projectCategories = [
  "All",
  ...new Set(projects.map(project => project.category))
];

/* ==========================================
   PROJECT TYPES
========================================== */
export const projectTypes = [
  ...new Set(projects.map(project => project.type))
];

/* ==========================================
   GET PROJECT INDEX
========================================== */
export const getProjectIndex = slug =>
  projects.findIndex(project => project.slug === slug);

/* ==========================================
   GET PROJECT BY SLUG
========================================== */
export const getProjectBySlug = slug =>
  projects.find(project => project.slug === slug);

/* ==========================================
   NEXT PROJECT
========================================== */
export const getNextProject = slug => {
  const index = getProjectIndex(slug);
  if (index === -1) return null;
  return projects[(index + 1) % projects.length];
};

/* ==========================================
   PREVIOUS PROJECT
========================================== */
export const getPreviousProject = slug => {
  const index = getProjectIndex(slug);
  if (index === -1) return null;
  return projects[(index - 1 + projects.length) % projects.length];
};

/* ==========================================
   PROJECTS BY CATEGORY
========================================== */
export const getProjectsByCategory = category => {
  if (category === "All") return projects;
  return projects.filter(project => project.category === category);
};

/* ==========================================
   PROJECTS BY TYPE
========================================== */
export const getProjectsByType = type =>
  projects.filter(project => project.type === type);

/* ==========================================
   SEARCH PROJECTS
========================================== */
export const searchProjects = query => {
  const search = query.trim().toLowerCase();

  if (!search) return projects;

  return projects.filter(project => {
    const searchableText = [
      project.title,
      project.description,
      project.category,
      project.type,
      project.status,
      project.year,
      project.timeline,
      project.developedBy,
      project.role,
      ...(project.technologies || [])
    ]
      .join(" ")
      .toLowerCase();

    return searchableText.includes(search);
  });
};

/* ==========================================
   RELATED PROJECTS
========================================== */
export const getRelatedProjects = (
  slug,
  limit = 3
) => {
  const currentProject = getProjectBySlug(slug);

  if (!currentProject) return [];

  return projects
    .filter(project => project.slug !== slug)
    .map(project => {
      let score = 0;

      if (project.category === currentProject.category) score += 3;
      if (project.type === currentProject.type) score += 2;
      if (project.featured) score += 1;

      return {
        ...project,
        score
      };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);
};

/* ==========================================
   PORTFOLIO STATISTICS
========================================== */
export const portfolioStats = {
  totalProjects: projects.length,
  featuredProjects: featuredProjects.length,
  categories: projectCategories.length - 1,
  types: projectTypes.length,
  technologies: new Set(
    projects.flatMap(project => project.technologies)
  ).size
};

/* ==========================================
   DEFAULT EXPORT
========================================== */
export default projects;